<div class="content-wrapper">
  <div class="container">
    <h1>Datenschutzerklärung</h1>

    <mat-card class="mat-card intro">
      <p>
        Der Schutz deiner Daten ist uns wichtig. Nachfolgend informieren wir dich darüber, welche personenbezogenen
        Daten wir verarbeiten, zu welchen Zwecken und auf welcher Rechtsgrundlage dies geschieht. Diese Hinweise gelten
        für die Nutzung von <strong>Rast‑WC.de</strong>.
      </p>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Verantwortlicher</h2>
      <p><strong>Rast‑WC.de</strong></p>
      <p>E‑Mail: <a href="mailto:kontakt&#64;rast-wc.de">kontakt&#64;rast-wc.de</a></p>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Welche Daten wir verarbeiten</h2>
      <ul>
        <li>
          Kontodaten (falls du ein Konto anlegst): z. B. Benutzername, ggf. E‑Mail. Passwörter werden serverseitig nur
          in sicher gehashter Form gespeichert.
        </li>

        <li>
          Inhalte und Nutzungsdaten: Bewertungen (Sterne, Kommentar, Zeitpunkt, Benutzername), Moderationsstatus (z. B.
          freigeschaltet/ausstehend).
        </li>

        <li>
          Geräte‑/App‑Einstellungen: Favoriten (Raststätten‑IDs) und Theme‑Auswahl werden lokal auf deinem Gerät
          gespeichert (LocalStorage). Diese Daten verlassen dein Gerät nicht, solange du sie nicht synchronisierst oder
          ein Konto‑Feature nutzt, das dies vorsieht.
        </li>

        <li>
          Technische Daten beim Seitenaufruf: IP‑Adresse, Datum/Uhrzeit, URL/Referrer, User‑Agent in Server‑Logfiles, um
          den Betrieb sicherzustellen und Missbrauch zu erkennen.
        </li>

        <li>
          Kartenanfragen: Um dir eine interaktive Karte anzuzeigen, nutzen wir die Open-Source-Bibliothek Leaflet. Die
          dafür benötigten Kartenkacheln werden von den Servern der OpenStreetMap Foundation (OSMF), St John’s
          Innovation Centre, Cowley Road, Cambridge, CB4 0WS, Großbritannien, geladen. Dabei wird deine IP-Adresse und
          dein User-Agent an die OSMF übermittelt. Weitere Informationen findest du in der Datenschutzerklärung von
          OpenStreetMap:
          <a href="https://osmfoundation.org/wiki/Privacy_Policy">[Link zur OSMF-Datenschutzerklärung]</a>.
        </li>
      </ul>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Zwecke und Rechtsgrundlagen</h2>
      <ul>
        <li>Bereitstellung der Website und Grundfunktionen (Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse).</li>
        <li
          >Nutzerkonto und Bewertungen (Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung bzw. vorvertragliche
          Maßnahmen).</li
        >
        <li>Missbrauchs‑/Betrugsprävention, Sicherheit, Stabilität (Art. 6 Abs. 1 lit. f DSGVO).</li>
        <li>Einwilligungen, sofern wir sie im Einzelfall einholen (Art. 6 Abs. 1 lit. a DSGVO).</li>
      </ul>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Speicherdauer</h2>
      <ul>
        <li>Kontodaten: bis zur Löschung deines Accounts bzw. wie gesetzlich erforderlich.</li>
        <li
          >Bewertungen: grundsätzlich dauerhaft, bis sie von dir gelöscht oder aus Moderations‑/Rechtsgründen entfernt
          werden.</li
        >
        <li
          >Server‑Logs: in der Regel 7–30 Tage, sofern keine längere Aufbewahrung zu Beweiszwecken erforderlich ist.</li
        >
        <li
          >Lokale Einstellungen (Favoriten/Theme): verbleiben auf deinem Gerät, bis du sie entfernst (z. B. über
          Browsereinstellungen).</li
        >
      </ul>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Empfänger und Drittlandübermittlungen</h2>
      <p>
        Hosting‑/Infrastruktur‑Dienstleister können im Rahmen der Auftragsverarbeitung Zugriff auf Daten erhalten. Beim
        Laden von Kartenkacheln (Leaflet) werden Anfragen an den jeweiligen Kartenanbieter gesendet; je nach Anbieter
        kann dies eine Übermittlung in Drittländer (außerhalb der EU/EWR) bedeuten. Wir wählen Anbieter mit einem
        angemessenen Datenschutzniveau aus oder nutzen geeignete Garantien gemäß Art. 44 ff. DSGVO.
      </p>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Cookies & lokale Speicherung</h2>
      <p>
        Wir verwenden nach aktuellem Stand keine Tracking‑Cookies. Technisch notwendige Informationen (z. B.
        Sitzungsinformationen oder Token) können in LocalStorage/SessionStorage oder als technisch erforderliche Cookies
        gespeichert werden, um die Anmeldung und Grundfunktionen zu ermöglichen. Favoriten und Theme‑Einstellungen
        speichern wir ausschließlich lokal auf deinem Gerät.
      </p>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Deine Rechte</h2>
      <ul>
        <li>Auskunft über die dich betreffenden personenbezogenen Daten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO) und Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO)</li>
        <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
      </ul>
      <p>
        Wende dich zur Ausübung deiner Rechte bitte an:
        <a href="mailto:kontakt&#64;rast-wc.de">kontakt&#64;rast-wc.de</a>
      </p>
    </mat-card>

    <mat-card class="mat-card">
      <h2>Sicherheit</h2>
      <p>
        Wir treffen angemessene technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau
        zu gewährleisten (z. B. Verschlüsselung, Zugriffsbeschränkungen, Datensparsamkeit).
      </p>
    </mat-card>

    <p class="as-of">Stand: 16.08.2025</p>
  </div>
</div>
